/* eslint-disable no-plusplus */
import moment from 'moment/moment'
import history from 'utils/history'
import Colors from './Colors'

export const isNetworkError = (err) => {
  return err.isAxiosError && !err.response
}
export const maskString = (str, pattern) => {
  if (!str) return null
  const patterns = {
    cpf: '###.###.###-##',
    cnpj: '##.###.###/####-##',
    cnae: '##.##-#-##',
  }
  let i = 0
  
  return patterns[pattern].replace(/#/g, () => {
    return str[i++]
  })
}

export const randomKey = (componentName = '') => {
  return `${componentName}_${Math.random().toString(36).substring(2, 10)}`
}

export const buildScore = (score) => {

  if (score <= 1.9) return { color: Colors.green }

  if (score >= 2 && score <= 2.99) return { color: Colors.yellow }

  if (score >= 3 && score <= 3.99) return { color: Colors.orange }

  return { color: Colors.red }
}

export const buildRiskColor = (riskLevel) => {
  const colors = {
    'UNDEFINED': Colors.textColor,
    'LOW': Colors.green,
    'MEDIUM': Colors.yellow,
    'HIGH': Colors.orange,
    'HIGH_PEP': Colors.orange,
    'HIGH_ATTENTION_LIST': Colors.orange,
    'VERY_HIGH': Colors.red,
    'VERY_HIGH_DENY_LIST': Colors.red,
  }

  return colors[riskLevel]
}

export const buildRiskMessage = (riskLevel) => {
  const messages = {
    undefined: 'N/A',
    'UNDEFINED': 'Indefinido',
    'LOW': 'Baixo',
    'MEDIUM': 'Médio',
    'HIGH': 'Alto',
    'HIGH_PEP': 'Alto (devido a ser PEP)',
    'HIGH_ATTENTION_LIST': 'Alto (devido a constar na "Attention List")',
    'VERY_HIGH': 'Muito Alto',
    'VERY_HIGH_DENY_LIST': 'Muito Alto ("Deny List")',
  }

  return messages[riskLevel]
}

export const convertToBrazilianCurrency = (value) => {
  return value.toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' })
}

export const dateFormats = {
  br_date_time: "DD/MM/yyyy HH:mm:ss",
  br_date: "DD/MM/yyyy",
}

export const formatDateTime = (value, format = dateFormats.br_date_time) => {
  return moment(value).format(format)
}

export const gotoUrl = (url) => {
  history.push({ pathname: url })
  history.go(0)
}
